import React from 'react'
import { BsWhatsapp } from 'react-icons/bs'

export default function FloatingButton() {
  return (
    <a
      target="_blank"
      href="https://wa.link/flores"
      className="fixed bottom-6 right-6 z-[51] flex h-14 w-14 items-center justify-center rounded-full bg-white shadow-lg outline-none drop-shadow-2xl transition-all duration-300 ease-in-out hover:scale-110 hover:shadow-xl xxs:h-16 xxs:w-16 md:bottom-8 md:right-8"
    >
      <BsWhatsapp size={30} className="text-green-600" />
    </a>
  )
}
